export default (accountNumber, cardPsType) => {
  const IS_FIRST_NUMBER_REGEX = /^\d/;
  const formattedHiddenСharacters = accountNumber.length === 16 ? ' **** **** ' : '**** ******';

  const formattedAccountNumber = IS_FIRST_NUMBER_REGEX.test(accountNumber)
    ? `${accountNumber.slice(0, 4)}${formattedHiddenСharacters}${accountNumber.slice(-4)}`
    : `${cardPsType} **** ${accountNumber.slice(-4)}`;

  return formattedAccountNumber;
};
